import { render, staticRenderFns } from "./TagBar.vue?vue&type=template&id=156c1c06&"
import script from "./TagBar.vue?vue&type=script&lang=js&"
export * from "./TagBar.vue?vue&type=script&lang=js&"
import style0 from "./TagBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports